import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        api.get("/settings").then(({ data }) => setSettings(data)).catch(() => setSettings({}));
    }, []);

    return <SettingsContext.Provider value={{ settings: settings || {} }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
